import { ChangeDetectionStrategy, Component, ElementRef, effect, inject, input } from '@angular/core';
import { SOCIAL_GLYPHS } from '../icon/icon-registry';

/** «Glifo de red» (Instagram, WhatsApp, Facebook, TikTok, X, Sitio web). `tile` = cuadro oscuro con glifo blanco. */
@Component({
  selector: 'app-social-glyph',
  standalone: false,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-hidden': 'true',
    '[class.is-tile]': 'tile()',
    '[style.--g]': "size() + 'px'",
    '[style.--t]': "tileSize() + 'px'",
  },
  styles: [`
    :host{display:inline-grid;place-items:center;flex:none;width:var(--g);height:var(--g);color:currentColor;line-height:0}
    :host ::ng-deep svg{width:var(--g);height:var(--g);display:block}
    :host(.is-tile){width:var(--t);height:var(--t);border-radius:10px;background:#111316;color:#fff}
  `],
})
export class SocialGlyphComponent {
  readonly code = input<string | null | undefined>('web');
  readonly size = input<number>(18);
  readonly tile = input<boolean>(false);
  readonly tileSize = input<number>(36);
  private el = inject(ElementRef<HTMLElement>);

  constructor() {
    effect(() => {
      const g = SOCIAL_GLYPHS[this.code() ?? ''] ?? SOCIAL_GLYPHS['web'];
      this.el.nativeElement.innerHTML = `<svg viewBox="${g.viewBox}" fill="none" xmlns="http://www.w3.org/2000/svg">${g.body}</svg>`;
    });
  }
}

export const GLYPH_CODES = ['instagram', 'whatsapp', 'facebook', 'tiktok', 'x', 'web'];
